import { Component, EventEmitter, Output } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { AuthService } from 'src/app/core/services/auth.service';

@Component({
  selector: 'app-help-modal',
  templateUrl: './help-modal.component.html',
  styleUrl: './help-modal.component.scss',
})
export class HelpModalComponent {
  // Modal dismiss event emitter
  @Output() dismiss = new EventEmitter();
  safeUrl: SafeResourceUrl;

  constructor(
    private sanitizer: DomSanitizer,
    private auth: AuthService
  ) {
    var user = this.auth.getUserInfo();

    const applicationHelp =
      'https://scribehow.com/page-embed/Initial_Application_Help__oT4lfF26QRekkHEaDUDJvA';
    const dashboardHelp =
      'https://scribehow.com/page-embed/Driver_Portal_Help__BlY6BCluSm2x913HcBeAlg';

    this.safeUrl = user?.DriverID
      ? this.sanitizer.bypassSecurityTrustResourceUrl(dashboardHelp)
      : this.sanitizer.bypassSecurityTrustResourceUrl(applicationHelp);
  }
  /**
   * Close modal event handler.
   */
  dismissModal() {
    this.dismiss.emit();
  }
}
